import React from 'react';
import style from './SavedFiltersHeader.module.scss';

export default function SavedFiltersHeader() {
  return (
    <div className={style.savedFiltersHeader}>
      <span>Saved Filters</span>
    </div>
  );
}
